import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import GridItemUI from 'hb-builder/components/UIComponents/page/block/Gallery/components/GridItem/GridItemUI';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { GridItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/galleryItemAttributes';

const GridItem: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<DocumentItem<GridItemAttributes>>) => {
  const { fontFamily, subdomainNetworkUrl, textColor } = useRendererContext();
  const newAttributes = {
    ...item?.attributes,
    fontFamily,
    textColor,
    subdomainNetworkUrl,
  };

  if (!item) {
    return null;
  }

  return <GridItemUI item={item} {...newAttributes} />;
};

GridItem.componentName = 'GridItem';
GridItem.Render = Render;

export default GridItem;
